module.exports = __webpack_public_path__ + "static/img/logo.a158874c.png";